<div>
  <div aria-live="polite" id="table-update-message" class="h-offscreen"></div>
  <ng-container *ngrxLet="isLoading$; let isLoading">
    <p-table
      [hidden]="!hitlist || hitlist.length === 0"
      #scrollTable
      [value]="tableRows"
      scrollHeight="var(--hitlist-scroll-height)"
      [scrollable]="true"
      responsiveLayout="scroll"
      selectionMode="single"
      data-cy="hitlist-table"
      >
      <ng-template pTemplate="header">
        <tr>
          @for (h of tableHeader; track h) {
            <th class="{{ h.scssClass }}" [attr.aria-label]="h.value"><span
            class="h-offscreen">Spaltentitel</span>{{ h.value }}</th>
          }

          <th class="action-header" pFrozenColumn alignFrozen="right" aria-label="Treffer Aktionen"><span
          class="h-offscreen">Spaltentitel Treffer Aktionen</span></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-hit let-i="rowIndex">
        @if (hit.isLoadingIndicator) {
          <tr class="loading-next-page-row">
            <ng-container>
              <td colspan="8">
                <p-progressSpinner strokeWidth="2" styleClass="custom-spinner"></p-progressSpinner>
              </td>
            </ng-container>
          </tr>
        }
        @if (hit.isSearchRestricted && minTableRowsReached() && !isLoading) {
          <tr class="search-restricted-row">
            <td colspan="8">
              <div class="filter-info">
                <div class="search-text-title">
                  <div>
                    <img class="search-warning-icon" src="/assets/icons/warning-icon.svg" alt="" />
                  </div>
                  <div>Suchresultate eingeschränkt</div>
                </div>
                @if ((areProfileFiltersSet$ | async) === false && minTableRowsReached() && !isLoading) {
                  <div
                    class="help-text"
                    >
                    Die Trefferliste wird durch deine Einstellungen eingeschränkt. Es werden möglicherweise
                    nicht alle Resultate angezeigt.
                    <a class="info-link" (click)="openProfileFiltersDialog()">Sucheinstellungen anpassen</a>
                  </div>
                }
              </div>
            </td>
          </tr>
        }
        @if (!hit.isSearchRestricted && !hit.isLoadingIndicator) {
          <tr
            [appHighlightRow]="i"
            (highlightedRowChanged)="highlightedRowIndex = $event"
            (appClickSingle)="goToDetails($event, hit)"
            (appClickDouble)="goToDetails($event, hit)"
            class="table-row"
            >
            <td class="hit-list-image" id="accessibility-duration{{ i }}">
              <img
                            [src]="
                                ($any(hit.keyframeBlob$ | async) | blobToObjectURL) ??
                                'assets/images/empty-keyframe.svg'
                            "
                alt="Treffer {{ i + 1 }}"
                />
                <div class="h-offscreen">Laufzeit {{ hit.durationAccessibilityString }}</div>
                <div class="duration" aria-hidden="true">
                  {{ hit.duration ?? "0" | millisecondsToDuration }}
                </div>
                @if (highlightedRowIndex === i) {
                  <div class="table-entry-number" aria-hidden="true">
                    {{ i + 1 }}
                  </div>
                }
              </td>
              <!-- Conditional rendering based on search type -->
              @if (lastResponseSearchType === SearchFieldSelectionEnum.WORD) {
                <td>
                  <div class="hit-list-program" [innerHTML]="hit.title | unsanitizedHtml"></div>
                  <div class="hit-list-date" [innerHTML]="hit.date | highlightedIso8601Date | unsanitizedHtml"></div>
                  <div class="hit-list-title" [pTooltip]="hit.itemTitleCellTip" [showDelay]="0" [escape]="false"
                    tooltipPosition="bottom" tooltipStyleClass="table-tooltip" (click)="$event.preventDefault()"
                  [innerHTML]="hit.itemTitle | unsanitizedHtml"></div>
                </td>
                <td>
                  <!-- "header" -->
                  <div class="hit-list-closed-caption-header">
                    @if (hit.hasNonOtonRatings) {
                      <span [pTooltip]="hit.ratings" tooltipPosition="left" [escape]="false">
                        <img src="assets/icons/diamond.svg" alt="Wertigkeit" class="inline-block-span" />
                      </span>
                    }
                    @if (hit.speaker) {
                      <span class="inline-block-span hit-list-closed-caption-speaker">
                        <span [innerHTML]="hit.speaker | unsanitizedHtml"></span>@if (hit.validated) {
                        <span> ({{ hit.validated }})</span>
                      }
                    </span>
                  }
                  @if (hit.context) {
                    <span class="hit-list-closed-caption-context">
                      <span>Kontext:&nbsp;</span><span [innerHTML]="hit.context | unsanitizedHtml"></span>
                    </span>
                  }
                </div>
                <!-- "body" with ClosedCaption text -->
                <div style="white-space: no-wrap;" [pTooltip]="hit.descriptionCellTip" [showDelay]="0" [escape]="false"
                  tooltipPosition="bottom" tooltipStyleClass="table-tooltip desc-tooltip"
                [innerHtml]="hit.description | unsanitizedHtml"></div>
              </td>
            } @else {
              <ng-container>
                <td class="hit-list-program" [innerHTML]="hit.title | unsanitizedHtml"></td>
                <td class="hit-list-date" [innerHTML]="hit.date | highlightedIso8601Date | unsanitizedHtml"></td>
                <td
                  class="hit-list-title"
                  [pTooltip]="hit.itemTitleCellTip"
                  [showDelay]="0"
                  [escape]="false"
                  tooltipPosition="bottom"
                  tooltipStyleClass="table-tooltip"
                  (click)="$event.preventDefault()"
                  [innerHTML]="hit.itemTitle | unsanitizedHtml"
                ></td>
                @if (hit.topicTooltip$) {
                  <ng-template #topicTooltipTemplate>
                    <div
                      class="topic-tooltip-content"
                      [innerHTML]="((hit.topicTooltip$ | async) ?? '') | unsanitizedHtml"
                    ></div>
                  </ng-template>
                  <td
                    class="hit-list-topic"
                    [pTooltip]="topicTooltipTemplate"
                    [showDelay]="0"
                    tooltipPosition="bottom"
                    tooltipStyleClass="table-tooltip desc-tooltip"
                  >
                    <span [innerHTML]="hit.description | unsanitizedHtml"></span>
                    <span
                      class="h-offscreen"
                      [innerHTML]="((hit.topicTooltip$ | async) ?? '') | unsanitizedHtml"
                    ></span>
                  </td>
                } @else {
                  <td
                    class="hit-list-topic"
                    [pTooltip]="hit.descriptionCellTip"
                    [showDelay]="0"
                    [escape]="false"
                    tooltipPosition="bottom"
                    tooltipStyleClass="table-tooltip desc-tooltip"
                    [innerHtml]="hit.description | unsanitizedHtml"
                  ></td>
                }
                <ng-template #constraintsTooltipTemplate>
                  <app-restriction-tooltip [restrictions]="hit.restrictions"></app-restriction-tooltip>
                </ng-template>
                <td class="hit-list-source">
                  @if (showConstraintTooltipLink(hit)) {
                    <div class="rights-label" [pTooltip]="constraintsTooltipTemplate" tooltipStyleClass="tooltip tooltip-rights-restrictions"
                      [escape]="false" tooltipPosition="left" appendTo="body">Rechte
                    </div>
                  }
                  @if (hit.source) {
                    <div [pTooltip]="hit.source" tooltipPosition="left" [escape]="false">Quelle</div>
                  }
                  @if (hit.ratings) {
                    <div [pTooltip]="hit.ratings" tooltipPosition="left" [escape]="false">
                      <img src="assets/icons/diamond.svg" alt="Wertigkeit" />
                    </div>
                  }
                </td>
              </ng-container>
            }
            <!-- default field layout, for all other search types -->
            <td class="action-icon-td" (click)="showActions($event, i)" pFrozenColumn alignFrozen="right">
              @if (highlightedRowIndex !== i) {
                <button
                  data-no-search
                  type="button"
                  class="p-table-icon-button"
                  id="{{ 'action-button-' + i }}"
                  (click)="showActions($event, i)"
                  >
                  <img src="assets/icons/ellipsis.svg" alt="Optionen" />
                </button>
              }
              @if (highlightedRowIndex === i) {
                <div class="p-table-action-button-container">
                  @if (!isAppInWebViewContainer || canUseShoppingCart) {
                    <button
                      data-no-search
                      title="Mit Vermerk in den Warenkorb"
                      pRipple
                      type="button"
                      class="p-table-action-button"
                      id="{{ 'order-with-remark-' + i }}"
                      (click)="orderWithRemark($event, hit, 'order-with-remark-' + i)"
                      >
                      <img src="assets/icons/order-with-remark.svg" alt="" />
                    </button>
                    <button
                      data-no-search
                      title="In den Warenkorb"
                      pRipple
                      type="button"
                      class="p-table-action-button"
                      id="{{ 'add-to-cart-' + i }}"
                      (click)="addToShoppingCart($event, hit, 'add-to-cart-' + i)"
                      >
                      <img src="assets/icons/shopping-cart-white.svg" alt="" />
                    </button>
                  }
                  @if (isAppInWebViewContainer && canUseDocSet && lastResponseSearchType !== SearchFieldSelectionEnum.WORD) {
                    <div class="break"></div>
                    <button
                      data-no-search
                      title="In das Docset"
                      pRipple
                      type="button"
                      class="p-table-action-button"
                      id="{{ 'add-to-docset-' + i }}"
                      (click)="addToDocSet($event, hit, 'add-to-docset-' + i)"
                      >
                      <img src="assets/icons/docset.svg" alt="" />
                    </button>
                  }
                </div>
              }
            </td>
          </tr>
        }
      </ng-template>
    </p-table>
  </ng-container>
</div>
